import React, {useReducer, useState} from 'react'
import PropTypes from 'prop-types'
import {Redirect} from 'react-router-dom'
import Browse from './Browse'
import Approve from './Approve'
import './index.scss'

const reducer = (state, action) => {
  switch (action.type) {
    case 'add': {
      return [...state, action.photo]
    }
    case 'remove': {
      return state.filter(photo => photo.id !== action.photo.id)
    }
    default: {
      throw new Error(`Unknown action ${action}`)
    }
  }
}

const AreaPhotos = ({match}) => {
  const estateId = match.params.estateId
  const [purchasedProductId, setPurchasedProductId] = useState(null)
  const [selectedPhotos, selectedPhotosReducer] = useReducer(reducer, [])
  const [step, setStep] = useState('browse')

  const StepComponent = step === 'approve' ? Approve : Browse

  if (purchasedProductId) {
    return (
      <Redirect to={`/oppdrag/${estateId}/produkt/${purchasedProductId}`} />
    )
  }

  return (
    <div className="estate area-photos">
      <StepComponent
        estateId={estateId}
        selectedPhotos={selectedPhotos}
        selectedPhotosReducer={selectedPhotosReducer}
        setStep={setStep}
        onPurchased={({id}) => setPurchasedProductId(id)}
      />
    </div>
  )
}

AreaPhotos.propTypes = {
  match: PropTypes.object.isRequired,
}

export default AreaPhotos
